export const routeConstants = {
    root: "/",
    login: "/login",
    signUp: "/sign-up",
    basicDetails: "/basic-details",
    agencyInformation: "/agency-information",

    //Profile,
    profile: {
        root: "/profile",
        editProfile: {
            root: "/profile/edit/",
            agency: {
                root: "/profile/edit/agency/",
                companyDetails: "company-details",
                contactInformation: "contact-information",
                socialMedia: "social-media",
            },
            personalDetails: "personal-details",
            contactDetails: "contact-details",
            photosAndVideos: "photos-and-videos",
            physicalDetails: "physical-details",
            experienceDetails: "experience-details",
            otherInterests: "other-interests",
            locationAndLanguages: "location-and-languages",
        },
    },

    // JOBS
    jobs: {
        root: "/jobs",
        listings: {
            root: "/jobs/listings",
            active: "active",
            inActive: "inactive",
            expired: "expired",
            drafts: "drafts",
        },
        postAJob: {
            root: "/jobs/post-a-job/",
            purpose: "purpose",
            location: "location",
            details: "details",
            advanceDetails: "advance",
            budget: "budget",
            success: "success",
            category: "category",
        },
        editAJob: {
            root: "/jobs/edit/",
            purpose: "purpose",
            location: "location",
            details: "details",
            budget: "budget",
            success: "success",
            advanceDetails: "advance",
            category: "category",
        },
    },

    // FIND
    findTalent: "/find-talent",
    findTalentRoot: {
        root: "/find-talent/",
        model: "model",
    },
    findWork: {
        root: "/find-work/",
        findWork: "find-work",
        details: "details",
        allJobs: "all-jobs",
        appliedJobs: "applied-jobs",
        likedJobs: "liked-jobs",
        invitation: "invitation",
        modelProfile: "model/profile",
    },

    // PRICING
    pricing: "/pricing",

    purchase: {
        success: "/purchase/success",
        cancel: "/purchase/cancel",
    },

    // HELP CENTER

    helpCenter: {
        root: "/help-center/",
        details: "details",
    },

    //SETTINGS
    settings: {
        root: "/settings/",
        accounts: "accounts",
        notifications: "notifications",
        subscriptions: "subscriptions",
        plans: "pricing",
    },

    //SAVED
    saved: "/saved",

    //Profile,
    // profile: "/profile",
    // editProfile: "/profile/edit",
    // editPersonalDetails: "/profile/edit/personal-details",
    // editContactDetails: "/profile/edit/contact-details",
    // editPhotosAndVideos: "/profile/edit/photos-and-videos",
    // editPhysicalDetails: "/profile/edit/physical-details",
    // editExperienceDetails: "/profile/edit/experience-details",
    // editOtherInterests: "/profile/edit/other-interests",
    // editLocationAndLanguages: "/profile/edit/location-and-languages",

    // JOBS
    postAJob: "/jobs/post-a-job",
    postJob: {
        root: "/jobs/post-a-job/",
        jobPurpose: "purpose",
        jobLocation: "location",
        jobDetails: "details",
        jobAdvanceDetails: "advance",
        jobBudget: "budget",
        success: "success",
        category: "category",
    },
    editAJob: "/jobs/edit",
    editJob: {
        root: "/jobs/edit/",
        jobPurpose: "purpose",
        jobLocation: "location",
        jobDetails: "details",
        jobAdvanceDetails: "advance",
        jobBudget: "budget",
        success: "success",
        category: "category",
    },
    // // FIND
    // findTalent: "/find-talent",
    // findWork: "/find-work",
    // workDetails: "/find-work/details",

    // // PRICING
    // pricing: "/pricing",

    // // HELP CENTER
    // helpCenter: "/help-center",
    // helpCenterDetails: "/help-center/details",

    // //SETTINGS
    // settings: "/settings",
    notificationSettings: "/settings/notifications",
    subscriptionSettings: "/settings/subscriptions",

    // //SAVED
    // saved: "/saved",
};
